import { render, staticRenderFns } from "./ouWechatUserManager.vue?vue&type=template&id=7450500a&scoped=true"
import script from "./ouWechatUserManager.vue?vue&type=script&lang=ts"
export * from "./ouWechatUserManager.vue?vue&type=script&lang=ts"
import style0 from "./ouWechatUserManager.vue?vue&type=style&index=0&id=7450500a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450500a",
  null
  
)

export default component.exports